"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NUMBER_OF_CONTACTS_EACH_CALL = exports.CONTACT_STATUS = void 0;
var CONTACT_STATUS = exports.CONTACT_STATUS = {
  UNRELATED: -1,
  PENDING: 0,
  ACCEPTED: 1,
  DECLINED: 2
};
var NUMBER_OF_CONTACTS_EACH_CALL = exports.NUMBER_OF_CONTACTS_EACH_CALL = 30;